/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, FormLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import { LocalStorageEnum } from '../../enums/LocalStorageEnum';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartLimitNote } from '../ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }

    }),
);

export enum DueDatesByPersonOptionEnum {
    PERSON_ACTING = 0,
    PERSON_ASSISTING,
    PERSON_RESPONSIBLE,
}

export enum DueDatesByPersonIncludeEnum {
    OVERDUE = 0,
    TODAY,
    NEXT_7_DAYS,
    NEXT_30_DAYS,
    ALL,
}

interface DueDatesByPersonChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: DueDatesByPersonOptionEnum;
    additionalOption?: DueDatesByPersonIncludeEnum;
}

interface ChartState {
    options: DueDatesByPersonOptionEnum;
    include: DueDatesByPersonIncludeEnum;
    dueDatesByGroup: DueDatesByGroup[];
    totalDueDatesCount: number;
}

export const DueDatesByPersonChart: React.FC<DueDatesByPersonChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const [state, setState] = useState<ChartState>({
        options: props.selectedOption === undefined ? DueDatesByPersonOptionEnum.PERSON_ACTING : props.selectedOption,
        include: props.additionalOption === undefined ? DueDatesByPersonIncludeEnum.OVERDUE : props.additionalOption,
        dueDatesByGroup: [],
        totalDueDatesCount: 0,
    });

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    // tslint:disable-next-line:no-any
    const salesPipelineQuery = useQuery<DueDatesByPersonData>(DUE_DATES_BY_PERSON_QUERY, {
        variables: {
            // groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        setState((prevState) => {
            let dueDatesByGroup: DueDatesByGroup[] = [];
            let totalDueDatesCount: number = 0;

            if (salesPipelineQuery.data && salesPipelineQuery.data.statistics && salesPipelineQuery.data.statistics.matter && salesPipelineQuery.data.statistics.matter.dueDates) {
                // tslint:disable-next-line: max-line-length
                const { dueDatesByPersonActing, dueDatesByPersonAssisting, dueDatesByPersonResponsible } = salesPipelineQuery.data.statistics.matter.dueDates;
                if (state.options === DueDatesByPersonOptionEnum.PERSON_ACTING) {
                    const { dueDatesByPersonAll, dueDatesByPersonNextSevenDays, dueDatesByPersonNextThirtyDays, dueDatesByPersonOverdue, dueDatesByPersonToday } =
                        dueDatesByPersonActing;

                    if (state.include === DueDatesByPersonIncludeEnum.OVERDUE) {
                        dueDatesByGroup = dueDatesByPersonOverdue.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonOverdue.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.TODAY) {
                        dueDatesByGroup = dueDatesByPersonToday.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonToday.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_7_DAYS) {
                        dueDatesByGroup = dueDatesByPersonNextSevenDays.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonNextSevenDays.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_30_DAYS) {
                        dueDatesByGroup = dueDatesByPersonNextThirtyDays.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonNextThirtyDays.totalDueDatesCount;
                    } else {
                        dueDatesByGroup = dueDatesByPersonAll.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonAll.totalDueDatesCount;
                    }
                } else if (state.options === DueDatesByPersonOptionEnum.PERSON_ASSISTING) {
                    const { dueDatesByPersonAll, dueDatesByPersonNextSevenDays, dueDatesByPersonNextThirtyDays, dueDatesByPersonOverdue, dueDatesByPersonToday } =
                        dueDatesByPersonAssisting;

                    if (state.include === DueDatesByPersonIncludeEnum.OVERDUE) {
                        dueDatesByGroup = dueDatesByPersonOverdue.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonOverdue.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.TODAY) {
                        dueDatesByGroup = dueDatesByPersonToday.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonToday.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_7_DAYS) {
                        dueDatesByGroup = dueDatesByPersonNextSevenDays.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonNextSevenDays.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_30_DAYS) {
                        dueDatesByGroup = dueDatesByPersonNextThirtyDays.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonNextThirtyDays.totalDueDatesCount;
                    } else {
                        dueDatesByGroup = dueDatesByPersonAll.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonAll.totalDueDatesCount;
                    }
                } else {
                    const { dueDatesByPersonAll, dueDatesByPersonNextSevenDays, dueDatesByPersonNextThirtyDays, dueDatesByPersonOverdue, dueDatesByPersonToday } =
                        dueDatesByPersonResponsible;

                    if (state.include === DueDatesByPersonIncludeEnum.OVERDUE) {
                        dueDatesByGroup = dueDatesByPersonOverdue.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonOverdue.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.TODAY) {
                        dueDatesByGroup = dueDatesByPersonToday.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonToday.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_7_DAYS) {
                        dueDatesByGroup = dueDatesByPersonNextSevenDays.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonNextSevenDays.totalDueDatesCount;
                    } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_30_DAYS) {
                        dueDatesByGroup = dueDatesByPersonNextThirtyDays.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonNextThirtyDays.totalDueDatesCount;
                    } else {
                        dueDatesByGroup = dueDatesByPersonAll.dueDatesByGroup;
                        totalDueDatesCount = dueDatesByPersonAll.totalDueDatesCount;
                    }
                }
            }

            return {
                ...prevState,
                dueDatesByGroup,
                totalDueDatesCount,
            };
        });
        // tslint:disable-next-line: align
    }, [salesPipelineQuery.data, salesPipelineQuery.loading, salesPipelineQuery.error, state.options, state.include]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isDueDatesByPersonChartOpen`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize(state.options, state.include);
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = state.dueDatesByGroup;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.dueDatesByGroup;
        // up 
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const onZoom = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Due Dates by ' + getGroupByTitle(state.options)));
            // tslint:disable-next-line: align
        }, 500);
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            if (state.include === DueDatesByPersonIncludeEnum.OVERDUE) {
                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Overdue' });
            } else if (state.include === DueDatesByPersonIncludeEnum.TODAY) {
                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Today' });
            } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_7_DAYS) {
                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextSevenDays' });
            } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_30_DAYS) {
                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextThirtyDays' });
            } else {
                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'All' });
            }

            const _tempTitle = `due dates ${getIncludeByTitle(state.include).toLowerCase()} breakdown by ${getGroupByTitle(state.options).toLowerCase()}`;

            props.getSelectedItem(searchCriterias, false, _tempTitle, DrillDownType.matterSummaryDrilldown, 'Next Due Date');
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = event.target.name;
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                [fieldName]: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const getIncludeByTitle = (include: DueDatesByPersonIncludeEnum) => {
        if (include === DueDatesByPersonIncludeEnum.OVERDUE) {
            return 'Overdue';
        } else if (include === DueDatesByPersonIncludeEnum.TODAY) {
            return 'Today';
        } else if (include === DueDatesByPersonIncludeEnum.NEXT_7_DAYS) {
            return 'In the next 7 days';
        } else if (include === DueDatesByPersonIncludeEnum.NEXT_30_DAYS) {
            return 'In the next 30 days';
        } else {
            return 'All';
        }
    };

    const getGroupByTitle = (option: DueDatesByPersonOptionEnum) => {
        if (option === DueDatesByPersonOptionEnum.PERSON_ACTING) {
            return localStorage.getItem(LocalStorageEnum.PersonActing) || 'Person Acting';
        } else if (option === DueDatesByPersonOptionEnum.PERSON_ASSISTING) {
            return 'Person Assisting';
        } else {
            return localStorage.getItem(LocalStorageEnum.PersonResponsible) || 'Person Responsible';
        }
    };
    
    if (salesPipelineQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    const dueDateCounts = state.dueDatesByGroup.map((dueDateByGroup: DueDatesByGroup) => dueDateByGroup.dueDatesCount);

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(dueDateCounts) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<EventOutlinedIcon />} title="Due Dates" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalDueDatesCount} format={(amount) => `${formatNumber(amount)}`} />
                </div>
                <div className={classes.title}>{getIncludeByTitle(state.include)}</div>
                <div className={classes.title}>{`Breakdown by ${getGroupByTitle(state.options)}`}</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton
                                size="medium"
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton
                                size="medium"
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const item = state.dueDatesByGroup.map((dueDateByGroup: DueDatesByGroup) => dueDateByGroup.groupedBy)[_index];

                            const searchCriterias = new Array<SearchCriteria>();
                            if (state.options === DueDatesByPersonOptionEnum.PERSON_ACTING) {
                                searchCriterias.push({ property: 'Acting', operator: 'eq', comparison: item });
                            } else if (state.options === DueDatesByPersonOptionEnum.PERSON_ASSISTING) {
                                searchCriterias.push({ property: 'Assisting', operator: 'eq', comparison: item });
                            } else {
                                searchCriterias.push({ property: 'Responsible', operator: 'eq', comparison: item });
                            }

                            if (state.include === DueDatesByPersonIncludeEnum.OVERDUE) {
                                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Overdue' });
                            } else if (state.include === DueDatesByPersonIncludeEnum.TODAY) {
                                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Today' });
                            } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_7_DAYS) {
                                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextSevenDays' });
                            } else if (state.include === DueDatesByPersonIncludeEnum.NEXT_30_DAYS) {
                                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextThirtyDays' });
                            } else {
                                searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'All' });
                            }

                            const _tempTitle = `${item} due dates ${getIncludeByTitle(state.include).toLowerCase()} breakdown by ${getGroupByTitle(state.options).toLowerCase()}`;
                            
                            props.getSelectedItem(
                                searchCriterias, 
                                false, 
                                _tempTitle, 
                                DrillDownType.matterSummaryDrilldown, 
                                'Next Due Date'
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.dueDatesByGroup.map((dueDateByGroup: DueDatesByGroup) => dueDateByGroup.groupedBy)),
                        datasets: [
                            {
                                label: 'Dates',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: dueDateCounts,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(dueDateCounts),
                                // suggestedMin: getMaxSuggestedTick(getHighestNumberInArray(dueDateCounts), 10),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(dueDateCounts),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                // min: 0,
                                // max: 9 // minimum display
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${formatNumber(currentValue)}`;
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {
                                        
                                        const { dataIndex } = context;

                                        const matters = state.dueDatesByGroup.map((dueDateByGroup: DueDatesByGroup) => dueDateByGroup.mattersCount)[dataIndex];

                                        return `Matters: ${formatNumber(matters)}`;
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(dueDateCounts) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div" className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                    Group By
                </FormLabel>
                <RadioGroup name="options" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel 
                        value={DueDatesByPersonOptionEnum.PERSON_ACTING} 
                        control={<Radio color="primary" />} 
                        label={localStorage.getItem(LocalStorageEnum.PersonActing) || 'Person Acting'} 
                    />
                    <FormControlLabel 
                        value={DueDatesByPersonOptionEnum.PERSON_ASSISTING} 
                        control={<Radio color="primary" />} 
                        label="Person Assisting" 
                    />
                    <FormControlLabel 
                        value={DueDatesByPersonOptionEnum.PERSON_RESPONSIBLE} 
                        control={<Radio color="primary" />} 
                        label={localStorage.getItem(LocalStorageEnum.PersonResponsible) || 'Person Responsible'}
                    />
                </RadioGroup>
            </FormControl>
            <FormControl component="div" className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                    Include
                </FormLabel>
                <RadioGroup name="include" value={state.include} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={DueDatesByPersonIncludeEnum.OVERDUE} control={<Radio color="primary" />} label="Overdue" />
                    <FormControlLabel value={DueDatesByPersonIncludeEnum.TODAY} control={<Radio color="primary" />} label="Today" />
                    <FormControlLabel value={DueDatesByPersonIncludeEnum.NEXT_7_DAYS} control={<Radio color="primary" />} label="Next 7 days" />
                    <FormControlLabel value={DueDatesByPersonIncludeEnum.NEXT_30_DAYS} control={<Radio color="primary" />} label="Next 30 days" />
                    <FormControlLabel value={DueDatesByPersonIncludeEnum.ALL} control={<Radio color="primary" />} label="All" />
                </RadioGroup>
            </FormControl>
            {state.dueDatesByGroup.length >= 10 && <ChartLimitNote>The top 10 are shown</ChartLimitNote>}
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export interface DueDatesByPersonData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    dueDates: DueDates;
}

export interface DueDates {
    dueDatesByPersonActing: DueDatesByPersonActingClass;
    dueDatesByPersonAssisting: DueDatesByPersonActingClass;
    dueDatesByPersonResponsible: DueDatesByPersonActingClass;
}

export interface DueDatesByPersonActingClass {
    dueDatesByPersonOverdue: DueDatesByPersonAllClass;
    dueDatesByPersonToday: DueDatesByPersonAllClass;
    dueDatesByPersonNextSevenDays: DueDatesByPersonAllClass;
    dueDatesByPersonNextThirtyDays: DueDatesByPersonAllClass;
    dueDatesByPersonAll: DueDatesByPersonAllClass;
}

export interface DueDatesByPersonAllClass {
    dueDatesByGroup: DueDatesByGroup[];
    totalDueDatesCount: number;
}

export interface DueDatesByGroup {
    dueDatesCount: number;
    groupedBy: GroupedBy;
    mattersCount: number;
}

export enum GroupedBy {
    AchillesThetis = 'Achilles Thetis',
    AlanFisher = 'Alan Fisher',
    AlbertWiley = 'Albert Wiley',
    AnabelHarvey = 'Anabel Harvey',
    MarelyStein = 'Marely Stein',
    None = '(none)',
    RohaanKathirgamathamby = 'Rohaan Kathirgamathamby',
    SimonButler = 'Simon Butler',
}

const DUE_DATES_BY_PERSON_QUERY = gql`
    query dueDateByPersonChart($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean) {
        statistics {
            matter {
                dueDates(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords) {
                    dueDatesByPersonActing {
                        dueDatesByPersonOverdue {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonToday {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonNextSevenDays {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonNextThirtyDays {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonAll {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                    }
                    dueDatesByPersonAssisting {
                        dueDatesByPersonOverdue {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonToday {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonNextSevenDays {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonNextThirtyDays {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonAll {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                    }
                    dueDatesByPersonResponsible {
                        dueDatesByPersonOverdue {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonToday {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonNextSevenDays {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonNextThirtyDays {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                        dueDatesByPersonAll {
                            dueDatesByGroup {
                                dueDatesCount
                                groupedBy
                                mattersCount
                            }
                            totalDueDatesCount
                        }
                    }
                }
            }
        }
    }
`;
